import React from 'react';

export default function Courses() {
  return (
    <section className="container">
      <h2>Certifications & Courses</h2>
      <ul>
        <li>Data Analytics with Python – NPTEL</li>
        <li>Java – Great Learning</li>
        <li>Web Dev with Python – Innovations Hub</li>
        <li>AWS – Alison/Simplilearn</li>
        <li>JavaScript Algorithms – freeCodeCamp</li>
      </ul>
    </section>
  );
}
